export function setTabVisibility(visible : boolean, id: string): void{
	const tabList = $(`#${id}`).closest('.tab-content').prev('ul.nav.nav-tabs');
	const targetTab = tabList.find(`> li > a[href='#${id}']`).closest(`li`);

	if (targetTab) {
		if (visible) {
			targetTab.removeClass('hidden');
		}
		else {
			if (targetTab.hasClass('active')) {
				selectAltenateTab(targetTab);
			}

			targetTab.addClass('hidden');
		}
	}

	const selectableTabs = tabList.find('> li').not('.hidden');
	const parent = tabList.parent();
	let toggleParentSubTab = false;

	if (selectableTabs.length == 1 && visible) {
		$(selectableTabs).find('> a').trigger('click');
		parent.removeClass('hidden');
		toggleParentSubTab = true;
	}

	if (selectableTabs.length == 0 && !visible) {
		parent.addClass('hidden');
		toggleParentSubTab = true;
	}

	if(toggleParentSubTab) {
		const parentSingleSubTab = parent.closest('.single-sub-tab')
		if (parentSingleSubTab.length) {
			setTabVisibility(visible, parentSingleSubTab.attr('id'));
		}
	}
}

function selectAltenateTab($targetTab : JQuery<HTMLLIElement>) {
	const nextTabs = $targetTab.nextAll('li').not('.hidden');

	for (const tab of nextTabs.get()) {
		$(tab).find('> a').trigger('click');
		return;
	}

	const previousTabs = $targetTab.prevAll('li').not('.hidden');

	for (const tab of previousTabs.get()) {
		$(tab).find('> a').trigger('click');
		return;
	}
}